import Row from "../row"
import IMG1 from "../../images/contact-img-2.png"

export default function ThirdRow () {
  return (
    <Row className="contact__3th-row">
      <img src={IMG1} alt="MAPS" />
    </Row>
  )
}